module.exports = __webpack_public_path__ + "static/media/81qpl4OcVLL._AC_UY606_.d63daa06.jpg";